import React from 'react';
import styles from './Main.module.sass';
import Section, { SectionBackgroundStyle } from '../../reusable/section/Section';
import Oblong from '../../assets/oblong_b.svg'
import Paintbrush from '../../assets/paintbrush.svg'
import RevealImage from '../../reusable/reveal/RevealImage';

export default class Main extends React.Component {

  render() {
    return (
      <Section style={SectionBackgroundStyle.mediumDark}>
        <h1 className={styles.Container}>
          <RevealImage className={styles.Oblong} src={Oblong} />
          <RevealImage className={styles.Paintbrush} src={Paintbrush} />
          <div className={styles.Item}>Our</div>
          <div className={styles.Item}>method.</div>
        </h1>
      </Section>
    )
  }

}
